import PCLNAnalytics from '@pcln/analytics'
import { updateListingsHasErrored, updateListingsIsLoading } from '../../../../reducers/listings'
import { setOverfilteredBannerText, setOverfilteredStatus } from '../../../../reducers/flags'

const handleError = ({ dispatch, error = {}, requestType, cguid }) => {
  if (typeof error === 'string') {
    error = { message: error }
  }
  const logError = {
    type: requestType,
    stack: error.stack || 'stack missing',
    message: error.message || 'message missing',
    messages: (error.messages && error.messages[0]) || 'if messages is an array and missing',
    code: error.code || error.errorCode || 'code is missing',
    cguid,
  }

  // TODO: add server side log
  PCLNAnalytics.logError(logError)

  dispatch(updateListingsIsLoading(false))

  if (requestType === 'FILTER') {
    dispatch(setOverfilteredBannerText(false))
    dispatch(setOverfilteredStatus(true))
  } else {
    dispatch(updateListingsHasErrored(true))
  }
}

export { handleError }
